import { Footer } from '@/components/Landing/LandingFooter';

import { buttons } from '@/styles/buttons';
import { fontStyles } from '@/styles/typography';

import { varMappings } from '@/utils/generated/varMappings';
import { routes } from '@/utils/routes';

export const Error500 = () => {
  return (
    <div
      className={`
            flex 
            flex-col 
            h-screen
            bg-[url(/images/landing/zen_lines_left_mobile.svg),url(/images/landing/zen_lines_right_mobile.svg)] 
            bg-[length:auto,auto] 
            bg-[position:0_25%,100%_75%] 
            bg-no-repeat
            bg-[color:${varMappings['special-background-app']}]
            tablet:bg-[url(/images/landing/zen_lines_left.svg),url(/images/landing/zen_lines_right.svg)]
            tablet:bg-[position:0_25%,100%_75%]
          `}
    >
      <div className="items-center flex flex-col h-full justify-center text-center w-full">
        <h1
          className={fontStyles({
            variant: 'H1',
            class: ['my-9 tablet:my-12 text-center text-900 tablet:text-1600'],
          })}
        >
          Something went wrong.
        </h1>
        <a
          className={buttons({ size: 'medium', color: 'black', shape: 'pill' })}
          href={routes.INDEX}
        >
          Back to home page
        </a>
      </div>
      <Footer />
    </div>
  );
};
